import { useId } from 'react';

export function Row({
	label,
	value,
	step = 1,
	onChange,
	disabled = false,
}: {
	label: string;
	value: number;
	step?: number;
	onChange: (v: number) => void;
	disabled?: boolean;
}) {
	const inputId = useId();
	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				gap: 10,
				marginBottom: 6,
			}}
		>
			<label htmlFor={inputId} style={{ fontSize: 12, color: disabled ? '#9aa6a2' : '#111' }}>
				{label}
			</label>
			<input
				id={inputId}
				type="number"
				step={step}
				value={value}
				disabled={disabled}
				onChange={(e) => onChange(Number(e.target.value))}
				style={{
					width: 110,
					fontSize: 13,
					padding: '4px 6px',
					border: '.5px solid #ddd',
					borderRadius: 6,
					background: disabled ? '#f0f2f1' : undefined,
					color: disabled ? '#9aa6a2' : undefined,
					cursor: disabled ? 'not-allowed' : undefined,
				}}
			/>
		</div>
	);
}
